
import React from 'react';
import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface PaymentFiltersProps {
  setStatusFilter: (status: string) => void;
  currentFilter?: string;
}

export const PaymentFilters: React.FC<PaymentFiltersProps> = ({ 
  setStatusFilter,
  currentFilter 
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Filter className="mr-2 h-4 w-4" />
          Фильтр {currentFilter && currentFilter !== 'all' && <span className="ml-1">({getFilterName(currentFilter)})</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          <DropdownMenuItem 
            onClick={() => setStatusFilter('all')}
            className={currentFilter === 'all' ? "bg-muted" : ""}
          >
            Все статусы
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setStatusFilter('paid')}
            className={currentFilter === 'paid' ? "bg-muted" : ""}
          >
            Оплачено
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setStatusFilter('completed')}
            className={currentFilter === 'completed' ? "bg-muted" : ""}
          >
            Завершено
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setStatusFilter('pending')}
            className={currentFilter === 'pending' ? "bg-muted" : ""}
          >
            Ожидание
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setStatusFilter('error')}
            className={currentFilter === 'error' ? "bg-muted" : ""}
          >
            Ошибка
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

function getFilterName(filter: string): string {
  switch (filter) {
    case 'paid': return 'Оплачено';
    case 'completed': return 'Завершено';
    case 'pending': return 'Ожидание';
    case 'error': return 'Ошибка';
    default: return filter;
  }
}
